import {OptionType} from '../../types/FormControlProps';

export type ChipsOption = {
  isDisabled?: boolean;
  suffix?: string;
} & OptionType;
